<template>
	<nav v-testid="'nav-menu'" :class="$style['app-aside-nav']">
		<ul
			v-if="navigation.length > 0"
			:class="$style['app-aside-nav__list']"
		>
			<AppAsideLink
				v-for="route in navigation"
				:key="route.name || route.path"
				:route="route"
				:status="status"
			/>
			<AppAsideExternalLink
				:class="$style['app-aside-nav__list-item']"
				:href="liteHost"
				:title="$t('common.fields.recar-lite')"
				:image="require('@/assets/images/dalys-logo-sm.png')"
			/>
		</ul>
	</nav>
</template>
<script>
import AppAsideExternalLink from './AppAsideExternalLink'
import AppAsideLink from './AppAsideLink'
import { GET_NAVIGATION } from '@/store/modules/App/Aside/action-types'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('App/Aside')

export default {
	name: 'AppAsideNavigation',
	components: {
		AppAsideLink,
		AppAsideExternalLink
	},
	props: {
		status: {
			type: String,
			required: true
		}
	},
	computed: {
		...mapGetters({
			navigation: 'navigation'
		}),
		liteHost () {
			return process.env.VUE_APP_HOST_RECAR_LITE
		}
	},
	created () {
		this.getNavigation(this.$router)
	},
	methods: {
		...mapActions({
			getNavigation: GET_NAVIGATION
		})
	}
}
</script>
<style lang="scss" module>
.app-aside-nav {
		overflow: hidden;
		overflow-y: auto;
		padding-bottom: 20px;
		height: 100%;
		-ms-overflow-style: none;
		scrollbar-width: none;

		&__list {
			height: 100%;
			display: flex;
			flex-flow: column;
			list-style: none;
			padding: 0;
			margin: 0;
		}

		&__list-item {
			margin-top: auto;
		}

		&::-webkit-scrollbar {
			width: 0;
			height: 0;
		}
	}
</style>
